<template>
  <a-layout class="design-customization">
    <div class="loading-container" v-if="loading">
      <div class="loading-container__loading">
        Wait until it finished...
        <spinner />
      </div>
    </div>
    <a-layout-header class="design-customization__header">
      <a-input-search
        size="large"
        placeholder="Identifier"
        @input="debounceSearch"
        @search="isIllustrator ? openOrNew() : () => {}"
      >
        <a-button
          v-if="isIllustrator && !loadingButton"
          type="primary"
          icon="plus"
          slot="enterButton"
          @click="openOrNew"
        >
          Open Or New
        </a-button>

        <a-button
          v-if="loadingButton"
          type="primary"
          slot="enterButton"
          disabled
        >
          <spinner />
        </a-button>
      </a-input-search>
    </a-layout-header>
    <a-button
      v-if="isIllustrator && !loadingButton"
      style="max-width: 600px; margin: 0 auto; width: 100%; height: 40px;"
      type="primary"
      icon="search"
      @click="goSearch"
    >
      Buscar
    </a-button>
    <a-layout-content class="design-customization__content">
      <section>
        <div class="tbl-header">
          <table cellpadding="0" cellspacing="0" border="0">
            <thead>
              <tr>
                <th>PREVIEW</th>
                <!-- <th>ID</th> -->
                <th>IDENTIFIER</th>
                <th class="th-lite">LITE</th>
                <th>OWNER</th>
                <th>MATERIAL</th>
                <th>GROUP</th>
                <th class="th-actions"></th>
              </tr>
            </thead>
          </table>
        </div>
        <div class="tbl-content">
          <table cellpadding="0" cellspacing="0" border="0">
            <tbody
              class="tbl-content-group"
              v-for="customization in customizations"
              :key="customization.id"
            >
              <tr
                v-for="item in available(customization)"
                :key="item.id"
                :class="isCurrent(item) ? 'active' : ''"
              >
                <td>
                  <mockup-preview
                    :material="
                      item.material ? item.material : 'standard-iphone6'
                    "
                    :stamps="[item.previewEn, item.previewPt, item.preview]"
                    :width="200"
                    :height="200"
                    :hideHeader="true"
                  />
                </td>
                <!-- <td>{{ item.id }}</td> -->
                <td>{{ item.identifier }}</td>
                <td class="td-lite">
                  <a-icon v-if="item.lite" type="like" />
                  <a-icon v-else type="deslike" />
                </td>
                <td>{{ item.ownerEmail }}</td>
                <td>{{ !item.material ? "default" : item.material }}</td>
                <td>{{ !item.group ? "default" : item.group }}</td>
                <td class="td-actions">
                  <a-button
                    v-if="isIllustrator"
                    class="td-actions__item"
                    type="primary"
                    icon="edit"
                    @click="edit(item)"
                  />
                  <a-button
                    v-if="!item.material"
                    class="td-actions__item"
                    type="primary"
                    icon="tablet"
                    @click="products(item)"
                  />
                  <a-button
                    v-if="isIllustrator && !item.material"
                    class="td-actions__item"
                    type="primary"
                    icon="copy"
                    @click="openCopyModal(item)"
                    :disabled="loading"
                  />
                  <a-button
                    v-if="isIllustrator"
                    class="td-actions__item"
                    type="primary"
                    icon="delete"
                    @click="destroy(item)"
                  />
                  <a-badge
                    v-if="!item.material"
                    class="td-actions__item"
                    :count="customization.length"
                  >
                    <a-button
                      type="primary"
                      :icon="isCurrent(item) ? 'up' : 'down'"
                      :disabled="!hasVariations(customization)"
                      @click="showVariations(item)"
                    />
                  </a-badge>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
    </a-layout-content>
    <a-layout-footer>
      <div class="pagination">
        <a-pagination
          simple
          :current="page"
          :page-size="perPage"
          :total="total"
          @change="onChange"
        />
      </div>
    </a-layout-footer>

    <a-modal v-model="copyModalVisibible" :title="titleCopy" centered>
      <a-form-model-item>
        <a-input
          v-model="copyIdentifier"
          placeholder="Digite o novo identifier"
        >
        </a-input>
      </a-form-model-item>
      <template slot="footer">
        <a-button key="back" @click="handleCancel">
          Fechar
        </a-button>
        <a-button
          key="submit"
          type="primary"
          :loading="loading"
          @click="copy"
          :disabled="!copyIdentifier"
        >
          Duplicar
        </a-button>
      </template>
    </a-modal>
  </a-layout>
</template>

<script>
import MockupPreview from "@/components/mockup-preview/MockupPreview.vue";
import Spinner from "@/components/spinner/Spinner.vue";
import {
  getCustomizations,
  destroyCustomization,
  duplicateCustomization,
} from "@/api/catalog-api/design-customization-api/designCustomization.api.js";

export default {
  components: { MockupPreview, Spinner },
  data() {
    return {
      customizations: [],
      currentIdentifier: null,
      perPage: 20,
      page: 1,
      total: null,
      loading: false,
      loadingButton: false,
      debounce: null,
      copyModalVisibible: false,
      copyIdentifier: null,
      selectedCopyIdentifier: null,
      inputSearch: "",
    };
  },
  computed: {
    titleCopy() {
      return `Copiar Identifier ${this.selectedCopyIdentifier}`;
    },
    isIllustrator() {
      return this.$store.getters.isIllustrator;
    },
    userToken() {
      return this.$store.state.token;
    },
  },
  watch: {
    currentIdentifier(id) {
      this.validateIdentifier();
      this.getCustomization();
      this.$router.push({
        query: {
          identifier: id,
        },
      });
    },
  },
  mounted() {
    if (this.$route.query.identifier)
      this.currentIdentifier = this.$route.query.identifier;
    this.getCustomization();
  },
  methods: {
    validateIdentifier() {
      if (!this.currentIdentifier) return;
      this.currentIdentifier = this.currentIdentifier
        .replace(/[^a-z0-9]/gi, "-")
        .toLowerCase();
    },
    handleCancel(e) {
      this.copyModalVisibible = false;
    },
    debounceSearch(event) {
      // clearTimeout(this.debounce);
      // this.debounce = setTimeout(() => {
      //   this.currentIdentifier = event.target.value;
      // }, 600);
      this.inputSearch = event.target.value;
    },
    goSearch() {
      this.currentIdentifier = this.inputSearch;
    },
    onChange(e) {
      this.page = e;
      this.getCustomization();
    },
    getCustomization() {
      this.loadingButton = true;
      const { perPage, page } = this;
      const identifier = this.currentIdentifier;
      return getCustomizations({ perPage, page, identifier }).then(
        (response) => {
          const customizations = response.customizations;
          let values = {};
          Object.keys(customizations).map(
            (key) =>
              (values[key] = customizations[key].sort((a, b) =>
                a.id < b.id ? -1 : a.id > b.id ? 1 : 0
              ))
          );
          this.total = response.count;
          this.customizations = values;
          this.loadingButton = false;
        }
      );
    },
    available(customizations) {
      if (!customizations) return;
      const children = customizations.find((c) => !c.material);
      if (!children) return;
      const { currentIdentifier } = this;
      if (children.identifier === currentIdentifier) return customizations;
      return [children];
    },
    hasVariations(customization) {
      return customization.length > 1;
    },
    showVariations(customization) {
      if (!customization) return;
      if (this.currentIdentifier === customization.identifier)
        this.currentIdentifier = null;
      else this.currentIdentifier = customization.identifier;
    },
    isCurrent(customization) {
      const { currentIdentifier } = this;
      return currentIdentifier === customization.identifier;
    },
    edit(customization) {
      let { identifier, material } = customization;
      if (!material) material = "standard-iphone6";
      this.$router.push({
        path: `/prisma-admin/${identifier}/${material}`,
        params: { identifier, material },
      });
    },
    destroy(customization) {
      var r = confirm(
        "WILL YOU REALLY WANT DESTROY THIS BEAUTIFUL CUSTOMIZATION?"
      );
      if (!r) return;
      const { id } = customization;
      return destroyCustomization({ id }, this.userToken)
        .then((res) => alert(res))
        .catch((err) => alert(err));
    },
    openOrNew() {
      const material = "standard-iphone6";
      this.$router.push({
        name: "PrismaAdmin",
        params: { identifier: this.inputSearch, material },
      });
    },
    products({ identifier }) {
      this.$router.push({
        name: "Products",
        params: { identifier },
      });
    },
    openCopyModal(item) {
      this.selectedCopyIdentifier = item.identifier;
      this.copyModalVisibible = true;
    },
    copy() {
      var r = confirm("ARE YOU SURE TO COPY THIS CUSTOMIZATION?");
      if (!r) return;

      this.loading = true;

      duplicateCustomization(this.selectedCopyIdentifier, this.copyIdentifier)
        .then((res) => {
          this.loading = false;
          this.endCopy();
          alert("Successfully copied!");
        })
        .catch((err) => {
          this.loading = false;
          this.endCopy();
          alert("An error occurred while copying");
        });
    },
    endCopy() {
      this.copyModalVisibible = false;
      this.selectedCopyIdentifier = null;
      this.copyIdentifier = null;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables.scss";
.design-customization {
  .design-customization__header {
    display: flex;
    align-items: center;
    justify-content: center;
    background: $white;
  }

  .design-customization__content {
    padding: 0 12px;
  }
}

section {
  height: 100%;
}

table {
  width: 100%;
  table-layout: fixed;
}

.tbl-header {
  background-color: rgba(255, 255, 255, 0.3);
  height: 57px;
}

.tbl-content {
  height: calc(100% - 57px);
  overflow-x: auto;
  margin-top: 0px;
  border: 1px solid rgba(255, 255, 255, 0.3);
}

tbody {
  tr {
    background-color: rgba(232, 195, 230, 0.5);
  }

  tr:nth-child(odd) {
    background-color: rgba(232, 195, 230, 0.7);
  }

  tr:first-child {
    background-color: $white;
    color: #333;
  }

  tr:first-child.active {
    background-color: rgba(232, 195, 230, 0.3);
    color: #333;
  }
}

th {
  padding: 20px 15px;
  text-align: left;
  font-weight: 500;
  white-space: nowrap;
  width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
}

th.th-lite {
  width: 60px;
}

th.th-actions {
  width: 62px;
}

td {
  padding: 15px;
  text-align: left;
  font-weight: 300;
  vertical-align: middle;
  border-bottom: solid 1px rgba(255, 255, 255, 0.1);
  width: 100%;
  overflow: hidden;
}

td.td-lite {
  font-size: 22px;
  width: 60px;
}

td.td-actions {
  width: 62px;

  .td-actions__item {
    margin: 8px 0;
  }
}

.pagination {
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.loading-container {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.8);
  z-index: 99;
  .loading-container__loading {
    color: #fff;
    margin: 12px;
    font-size: 22px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .spinner {
      margin: 12px;
    }
  }
}
</style>
